import { app } from '../../../../../../app';
import { Controller } from './remove-accounts-from-group.controller';

app.component('companyUserDirectoriesManageGroupAccountsRemove', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./remove-accounts-from-group.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/remove/remove-accounts-from-group.component.js